<template>
  <div>

      <macro-component view="macro-menu-options" listPosition="left" containerWith="14rem" icon="arror-right" route="/FrontOffice/Transactions"/>
  </div>
</template>

<script>
import { Macro } from "@credenceanalytics/components";
import Vue from "vue";
Vue.use(Macro, { applicationName: "cashtrea" , macroJSFileUrl: "/macros/macro.js"})
export default {
  name:'macro-test-component'
}
</script>
